import { PolicyTypeEnum } from '../classes/PolicyTypeEnum';
import getServerSidePolicyType from '../utils/getServerSidePolicyType';
import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';

export const generatePolicyAsync = (policyType: PolicyTypeEnum, orderId: string) =>
  APIFactory(baseUrlService.ApiLocation).post(
    `/documents/v2/generate_policy/${getServerSidePolicyType(policyType)}/${orderId}`
  );
